export function createHeaders(authToken?: string) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'Pronto',
  }

  return authToken ? { ...headers, Authorization: `Bearer ${authToken}` } : headers
}
